import { render } from "./VnfAppliancesTab.vue?vue&type=template&id=6dc630fe&scoped=true"
import script from "./VnfAppliancesTab.vue?vue&type=script&lang=js"
export * from "./VnfAppliancesTab.vue?vue&type=script&lang=js"

import "./VnfAppliancesTab.vue?vue&type=style&index=0&id=6dc630fe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc630fe"]])

export default __exports__